import { ValueOf } from '@direct-frontend/stdlib';

export type OperatorType = ValueOf<typeof OperatorType>;
/**
 * Доступные типы операторов
 * @kind enum
 */
// eslint-disable-next-line @direct-frontend/modules/no-runtime-code-in-types -- это enum
export const OperatorType = {
    /** Равно */
    Eq: '=',
    /** Больше или равно */
    Ge: '>=',
    /** Меньше */
    Lt: '<',
    /** Больше */
    Gt: '>',
    /** Меньше или равно */
    Le: '<=',
    /** Содержит */
    Like: 'contains',
    /** Не равно */
    Ne: '!=',
    /** Не содержит */
    NotLike: 'not-contains',
} as const;

/** Наборы операторов */
export type OperatorSet = 'all' | 'equals' | 'compares';
